import type { ReactNode } from 'react';

export const symbol_battery_charging_30_2: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M120-290q-12 0-21-9t-9-21v-320q0-12 9-21t21-9h455q13 0 21.5 8.5T605-640q0 13-8.5 21.5T575-610H310v260h243q13 0 21.5 8.5T583-320q0 13-8.5 21.5T553-290H120Zm587-160h-95q-10 0-14-8t2-16l126-157q4-5 8.5-6t9.5 1q5 2 7 6.5t1 10.5l-19 109h95q10 0 14 8t-2 16L714-329q-4 5-8.5 5.5T696-325q-5-2-7-6t-1-10l19-109Z"
		/>
	</svg>
);
